export default __webpack_public_path__ + "static/media/nelson_chicas-01.f88d3b73.png";